import { Box, CircularProgress } from "@mui/material";


export const LoaderScreen = () => {
    return (
        <Box sx={{ display: 'flex', height: '92vh', backgroundColor: 'white', alignContent: 'center', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress />
        </Box>
    );
}